import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const _authService = inject(AuthService);
  const _router = inject(Router);

  try {
    const user = await _authService.getCurrentUser();
    const session = await _authService.getCurrentSession();

    // ✅ Authenticated user
    if (user && session?.provider !== 'anonymous') return true;

    // 🚫 Redirect to login for any other route
    return _router.parseUrl('/login');
  } catch (error) {
    return _router.parseUrl('/login');
  }
};
